<template>
    <el-dialog title="Мессеж загвар үүсгэх" v-model="sendMessageDialog" width="50%">
      <el-row>
        <el-col class="mb-20">
          Утасны дугаар: <span class="red_color">*</span>
          <el-input type="number" v-model="formData.phone"></el-input>
        </el-col>
        <el-col class="mb-20">
          Мессеж текст: <span class="red_color">*</span>
          <el-input type="textarea" v-model="formData.sms_text"></el-input>
        </el-col>
        <el-col>
          <el-button type="success w-100" @click="submitForm()">Мессеж илгээх</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </template>

<script>
import services from '../services'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SendMessageDialog',
  data () {
    return {
      formData: {
        phone: null,
        sms_text: null
      }
    }
  },
  computed: {
    ...mapState(['sendMessageDialog'])
  },
  props: {
    selectedMessage: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    selectedMessage: {
      immediate: true, // Хэрэглэгчийн өгөгдөл анх ороход ажиллана
      handler (newValue) {
        this.formData = {
          ...newValue
        }
      }
    }
  },
  methods: {
    ...mapActions(['setSendMessageDialog']),
    handleClose () {
      this.formData = {}
      this.setSendMessageDialog(false)
    },
    async submitForm () {
      if (!this.formData.phone) {
        this.$notify({
          title: 'Уучлаарай',
          message: 'Та мессеж илгээх утасны дугаар оруулна уу.',
          type: 'error',
          duration: 3000
        })
        return
      }
      if (!this.formData.sms_text) {
        this.$notify({
          title: 'Уучлаарай',
          message: 'Та мессеж илгээх текст оруулна уу.',
          type: 'error',
          duration: 3000
        })
        return
      }
      const payload = { phone: this.formData.phone, sms_text: this.formData.sms_text }
      try {
        // const apiCall = services.get('sendSms', payload)
        const apiCall = services.get(`sendSms/?phone=${payload.phone}&sms_text=${payload.sms_text}`)

        await apiCall
        this.$notify({
          title: 'Амжилттай',
          message: 'Мессеж амжилттай илгээгдлээ..',
          type: 'success'
        })
        this.handleClose()
      } catch (error) {
        console.error('API Request Error:', error.message)
        this.$notify({
          title: 'Алдаа',
          message: error.message || 'Сүлжээний алдаа гарлаа.',
          type: 'error'
        })
      }
    }
  }
}

</script>

  <style scoped>
    .el-form {
      max-width: 600px;
      margin: 0 auto;
    }
    .red_color {
      color: red;
    }
    .mb-20 {
      margin-bottom: 20px;
    }
  </style>
